export const menu = {
  pokebowls: [
    {
      title: "🥣 Pink Granola Bowl",
      price: "65DH",
      content: [
        "Strawberry yogurt",
        "Granola",
        "Fresh fruits"
      ],
      image: "/images/pink-granola.png"
    },
    {
      title: "🥣 Natur Granola Bowl",
      price: "55DH",
      content: [
        "Nature yogurt",
        "Granola",
        "Fresh fruits"
      ],
      image: "/images/natur-granola.png"
    },
    {
      title: "🥣 Marina Chicken Bowl",
      price: "95DH",
      content: [
        "Rice: Sushi rice",
        "Mix-ins: Cherry tomatoes, corn, mango, cucumber, onion",
        "Protein: Sweet chicken",
        "Sauce: Sriracha mayo",
        "Toppings: Crunchy onions"
      ],
      image: "/images/marina-chicken.png"
    },
    {
      title: "🐟 Atlantic Bowl",
      price: "100DH",
      content: [
        "Rice: Sushi rice",
        "Mix-ins: Cherry tomatoes, avocado, mango, seaweed, onions",
        "Protein: Nordic salmon",
        "Sauce: Sriracha mayo",
        "Toppings: Crunchy onions, spring onions"
      ],
      image: "/images/atlantic.png"
    },
    {
      title: "🔥 Ultra Me3elem Bowl",
      price: "120DH",
      content: [
        "Rice: Sushi rice",
        "Mix-ins: Cherry tomatoes, cucumber, seaweed, mango, edamame, mango",
        "Protein: Raw salmon & sweet chicken",
        "Sauce: Sriracha mayo & ginger syrup",
        "Toppings: Crunchy onions"
      ],
      image: "/images/me3elem.png"
    },
    {
      title: "🍃 Jumuha Bowl",
      price: "95DH",
      content: [
        "Rice: Couscous rice",
        "Mix-ins: Cucumber, avocado, paprika, cherry tomatoes, onions",
        "Protein: Chicken",
        "Sauce: Ginger syrup",
        "Toppings: B'sal ou zwib, mint, coriander"
      ],
      image: "/images/jumuha.png"
    }
  ],
  dessertsAndDrinks: [
    {
      title: "🍵 Matcha with cocomilk",
      price: "45DH",
      description: "Matcha, coconut milk, served cold"
    },
    {
      title: "🍵 Matcha with nature milk",
      price: "42DH",
      description: "Matcha with fresh milk, earthy and energizing"
    },
    {
      title: "🍵 Matcha with Raibi",
      price: "48DH",
      description: "Matcha with Raibi (fermented milk), sweet fusion"
    },
    {
      title: "🥞 Poke Pancake",
      price: "52DH",
      description: "Fluffy pancakes with seasonal toppings and cream"
    },
    {
      title: "🥞 Nutella Banana Pancake",
      price: "38DH",
      description: "Pancake with Nutella and banana slices"
    },
    {
      title: "🥞 Fresh Fruits Pancake",
      price: "49DH",
      description: "Topped with a mix of fresh fruits"
    },
    {
      title: "🥞 Caramel Pancake",
      price: "35DH",
      description: "Choice of topping: caramel"
    },{
      title: "🥞 Honey Pancake",
      price: "35DH",
      description: "Choice of topping: honey"
    },{
      title: "🥞 Nutella Pancake",
      price: "35DH",
      description: "Choice of topping: Nutella"
    },
    {
      title: "🍊 Jus Orange",
      price: "26DH",
      description: "100% fresh pressed orange juice"
    },
    {
      title: "🍋 Jus Citron",
      price: "25DH",
      description: "Lemon juice with mint"
    },
    {
      title: "🥤 Panaché",
      price: "30DH",
      description: "Fruit milkshake blend (banana, orange, milk)"
    },
    {
      title: "🥤 Jus Pressé (Pomme – Ananas – Fraise)",
      price: "30DH",
      description: "Choose from apple, pineapple, or strawberry"
    },
    {
      title: "🫖 Thé à la menthe",
      price: "21DH",
      description: "Traditional Moroccan mint tea"
    },
    {
      title: "☕ Café noir",
      price: "21DH",
      description: "Black coffee"
    },
    {
      title: "☕ Cappuccino",
      price: "25DH",
      description: "Creamy cappuccino with milk foam"
    },
    {
      title: "🍹 Mojito Virgin Red",
      price: "32DH",
      description: "Strawberry, lime, mint, sparkling water"
    },
    {
      title: "🍹 Mojito Virgin Green",
      price: "32DH",
      description: "Lime, mint, soda, sugar syrup"
    },
    {
      title: "🍓 Spécialité Mixte Fruits",
      price: "50DH",
      description: "Seasonal fruits with topping of your choice"
    }
  ],
  breakfast: [
    {
      title: "Marocain",
      price: "60DH",
      content: [
        "Traditional breads (msimen, harcha, baghrir)",
        "Cheese, olives, amlou, honey, butter",
        "Moroccan mint tea",
        "Mini-bowl"
      ]
    },
    {
      title: "Fassi",
      price: "50DH",
      content: [
        "Traditional khlii (dried spiced meat)",
        "Scrambled eggs, harcha or baghrir",
        "Olives, cheese, olive oil",
        "Moroccan mint tea, Mini-bowl"
      ]
    },
    {
      title: "Spanish",
      price: "55DH",
      content: [
        "Spanish omelette (with peppers & onions)",
        "Toast, grilled tomatoes, turkey ham",
        "Fresh orange juice",
        "Coffee or tea, Mini-bowl"
      ]
    },
    {
      title: "French",
      price: "50DH",
      content: [
        "Croissant, pain au chocolat",
        "Baguette with butter & jam",
        "Fresh orange juice",
        "Coffee with milk or tea, Mini-bowl"
      ]
    },
    {
      title: "🍳 Omelette Nature",
      price: "20DH",
      description: "Simple 3-egg omelette"
    },
    {
      title: "🍳 Omelette Fromage",
      price: "25DH",
      description: "Omelette with melted cheese"
    },
    {
      title: "🍳 Omelette Fromage Dinde",
      price: "30DH",
      description: "Omelette with cheese and smoked turkey"
    },
    {
      title: "🍳 2 Oeufs au Plat",
      price: "22DH",
      description: "Two fried eggs"
    }
  ],
  breakfastImage: "/images/breakfast.png"
}; 